import PersonaCrud from './PersonaCrud'
export {PersonaCrud}
export default PersonaCrud
